import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser, getMeds, getMedsHistory, setCurrentUser } from '../../store/storeValtio.js';
import { generateUniqueId, getNowISO, parseForm, validateEmail } from '../../helpers/generalHelpers.js';
import { deleteAllTransactionsFromDb, updateUserInDb } from 'store/localDb.js';
import { registerFirestore, syncData } from 'helpers/apiHelpers.js';
import { updateData } from 'store/idb.js';
//import history from 'store/history';

export default function Register() {
  console.log('Register');
  const [submitting, setSubmitting] = useState(false);
  const [ errors, setErrors ] = useState()
  const [ submitError, setSubmitError ] = useState()
  const navigate = useNavigate();

  const currentUser = getCurrentUser();

  async function handleSubmit(e) {
    e.preventDefault()

    // validate form data
    const formItems = e.target;
    console.log('formItems', formItems);
    var formVals = parseForm(formItems);
    console.log('formVals', formVals);
    // get our new errors
    const fe = findFormErrors(formVals)
    console.log('form errors: ', fe);
    if (fe) return;

    // No errors! Put any logic here for the form submission!
    setSubmitting(true);
    const newReg = {
      registrationDate: getNowISO(),
      registrationId: currentUser.userId,
      displayName: formVals.displayName,
      firstName: formVals.firstName,
      lastName: formVals.lastName,
      email: formVals.email,
      awakeTime: currentUser.awakeTime,
      bedTime: currentUser.bedTime,
      password: formVals.password,
    }
    const result = await registerFirestore(newReg);
    console.log('registerFirestore result: ', result);

    // update user data locally
    var updatedProfile = {
      userId: currentUser.userId,
      displayName: currentUser.displayName,
      firstName: formVals.firstName,
      lastName: formVals.lastName,
      awakeTime: currentUser.awakeTime,
      bedTime: currentUser.bedTime,
      email: formVals.email,
      registrationDate: newReg.registrationDate,
      registrationId: newReg.registrationId,
      dateUpdated: getNowISO()
      }

    try {
      console.log('updateProfile', updatedProfile);
      let result = await updateData('users', updatedProfile)
      console.log('updateProfile', result);
      setCurrentUser( updatedProfile );
    } catch (error) {
      console.log('updateProfile error', error);
      setSubmitError(error.message);
      setSubmitting(false);
      return;
    }

    // copy data to firestore

    await deleteAllTransactionsFromDb();
    let data = getMeds();
    await syncData('saveMeds', data);
    data = getMedsHistory();
    await syncData('saveHist', data);
    
    setSubmitting(false);
    navigate('/');
}

function findFormErrors(vals) {
    const password = vals.password;
    const confirm = vals.confirmPassword;

    if ( !vals.displayName || vals.displayName === '' ) {
      setErrors('Display Name cannot be blank!');
      return true;
    }
    if ( !vals.firstName || vals.firstName === '' ) {
      setErrors('Password cannot be blank!');
      return true;
    }
    if ( !vals.lastName || vals.lastName === '' ) {
      setErrors('Password cannot be blank!');
      return true;
    }
    if (!validateEmail(vals.email)) {
      setErrors('Email format is invalid!');
      return true;
    }
    if ( !password || password === '' ) {
      setErrors('Password cannot be blank!');
      return true;
    }
    if ( password.length < 6 ) {
      setErrors('Password must be at least 6 characters');
      return true;
      }
    if ( !confirm || confirm === '' ) {
      setErrors('Confirm cannot be blank!');
      return true;
    }
    if ( confirm.length < 6 ) {
      setErrors('Confirm must be at least 6 characters');
      return true;
      }
    if ( (password && confirm) && (confirm !== password )) {
      setErrors('Password and Confirm do not match!');
      return true;
      }
    setErrors(null);
    return false;
  }

  return (
    <div className='container w-full'>
    <div className='min-h-screen bg-gray-100 py-4 px-6 tablet:px-8'>
      <div className='mx-auto w-full max-w-md mb-4'>
        <h2 className='mt-6 text-center text-3xl font-extrabold text-gray-900'>
          Please enter your registration data
        </h2>
      </div>

      <div className='mt-4 mx-auto w-full max-w-md'>
        {(errors || submitError) && (
          <div
            className='bg-red-100 rounded-lg py-5 px-6 mb-3 text-base text-red-700'
            role='alert'
          >
            {errors}{submitError}
          </div>
        )}

        <div className='bg-white py-8 px-6 shadow rounded-lg'>
          <form className='mb-0 space-y-6' onSubmit={handleSubmit}>
          <div>
              <label htmlFor='displayName' className='block text-sm font-medium text-gray-700' > Display name </label>
              <div className='mt-1'>
                <input 
                  className='formText'
                  id='displayName' 
                  name='displayName' 
                  type='text' 
                  autoComplete='name' 
                  required
                  defaultValue={currentUser.displayName} 
                  /> 
              </div>
            </div>
            <div>
              <label htmlFor='firstName' className='block text-sm font-medium text-gray-700' > First name </label> 
              <div className='mt-1'>
                <input 
                  className='formText'
                  id='firstName' 
                  name='firstName' 
                  type='text' 
                  autoComplete='name' 
                  required
                  defaultValue={currentUser.firstName}
                  /> 
              </div>
            </div>
            <div>
              <label htmlFor='lastName' className='block text-sm font-medium text-gray-700' > Last Name </label> 
              <div className='mt-1'>
                <input 
                  id='lastName' 
                  name='lastName' 
                  type='text' 
                  autoComplete='name' 
                  required className='formText'
                  defaultValue={currentUser.lastName}
                  /> 
              </div>
            </div>
            <div>
              <label htmlFor='email' className='block text-sm font-medium text-gray-700' > Email address </label> 
              <div className='mt-1'>
                <input 
                  id='email' 
                  name='email' 
                  type='email' 
                  autoComplete='email' 
                  required className='formText'
                  defaultValue={currentUser.email}
                  /> 
              </div>
            </div>
            <div>
              <label htmlFor='password' className='block text-sm font-medium text-gray-700' > Password </label> 
              <div className='mt-1'>
                <input 
                  id='password' 
                  name='password' 
                  type='password' 
                  autoComplete='password' 
                  required className='formText' 
                  defaultValue='EatItRaw'
                  /> 
              </div>
            </div>
            <div>
              <label htmlFor='confirmPassword' className='block text-sm font-medium text-gray-700' > Password Confirm </label>
              <div className='mt-1'>
                <input 
                  id='confirmPassword' 
                  name='confirmPassword' 
                  type='password' 
                  autoComplete='password' 
                  required className='formText' 
                  defaultValue='EatItRaw'
                  /> 
              </div>
            </div>
            <div className='flex justify-between'>
              <button type='submit' disabled={submitting} className='okBtn float-left'>Register</button> 
              <button onClick={()=>navigate(-1)} type='button' className='cancelBtn float-right'>Cancel</button> 
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
);
}
